/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styles from '../logs.module.scss';

const DetailsStatus = ({ current_stage, reviewSetting }) => {
  const [values, setValues] = useState([]);

  const handleStage = (id) => {
    const stages = [
      { id: 1, title: 'Pending Approval', isCompleted: false, isActive: false },
      { id: 2, title: `${current_stage === 'pending' ? 'Approved/Rejected' : current_stage}`, isCompleted: false, isActive: false }
    ];
    const update_values = stages;
    update_values.forEach((val) => {
      if (val.id <= id) {
        if (val.id === id) {
          val.isActive = true;
        } else {
          val.isCompleted = true;
        }
      }
      if (id === 3 || id === 8 || id === 9) {
        val.isCompleted = true;
      }
      if (reviewSetting && val.id === 1) {
        val.title = 'Initial Review';
      }
      if (reviewSetting && val.id === 2) {
        val.title = 'Manager Approval';
      }
      if (id === 8) {
        val.title = 'Suspended';
      }
      if (id === 9) {
        val.title = 'Revoke';
      }
      if (id === 15) {
        val.title = 'Application Withheld';
      }
    });
    setValues(update_values);
  };

  const handleCurrentStage = (val) => {
    if (val !== undefined) {
      switch (val) {
        case 'Approved':
          handleStage(3);
          break;
        case 'Rejected':
          handleStage(3);
          break;
        default:
          handleStage(1);
          handleStage(2);
          break;
      }
    }
  };

  useEffect(() => {
    handleCurrentStage(current_stage);
  }, [current_stage, reviewSetting]);

  return (
    <div className={styles.body_container}
      style={{ width: '60%', padding: 0, margin: 'auto', marginTop: '2%', marginBottom: 0 }}
    >
      <div className={styles.card}>
        {values.map(value => (
          <div className={`${styles.cardItem} 
            ${value.isActive === true ? styles.active : ''}
            ${value.isCompleted === true ? styles.completed : ''}`}
          >
            <span className={styles.circle}>
              {value.isCompleted
                ? <span className={styles.tick}>&#10003;</span>
                : <span className={styles.id_style}>{value.id}</span>
              }
            </span>
            <span className={styles.descp}>{value.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailsStatus;
